/**
 * A wrapper for a route that automatically tracks pageviews when the route
 * changes.
 *
 * @see https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker
 */

import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';
import analytics from 'config/analytics';

GoogleAnalytics.initialize(analytics.gaId);

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname; // eslint-disable-line react/prop-types
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;



// WEBPACK FOOTER //
// ./app/services/withTracker.js